import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import "./style.css";
import headquarterImage from "../../assets/img/nbrri-headquarters2.jpg";
import OwlCarouselComponent from "../../components/owlCarousel/owlcarousel.component";
// import Carousel from "../../components/Carousel/index.jsx";

export class HomePage extends Component {
  render() {
    return (
      <React.Fragment>
        <section id="hero">
          <div className="hero-container">
            <h1>Welcome to NBRRI</h1>
            <h2>Research Portal</h2>
            <a
              href="https://www.nbrrilibrary.org.ng/"
              target="_blank"
              className="btn-get-started scrollto"
            >
              Go to E-Library
            </a>
          </div>
        </section>
        <React.Fragment>
          <section id="about" className="about">
            <div className="container">
              <div className="section-title">
                <h2>About Us</h2>
              </div>

              <div className="row">
                <div className="col-lg-6 order-1 order-lg-2">
                  <img src={headquarterImage} className="img-fluid" alt="" />
                </div>
                <div className="col-lg-6 pt-4 pt-lg-0 order-2 order-lg-1">
                  <h3>
                    The Nigerian Building and Road Research Institute (NBRRI) is
                    one of the parastatals under the aegis of the Federal
                    Ministry of Science and Technology (FMST).
                  </h3>
                  <p className="font-italic">
                    It was established on 1st April 1978 by the Federal
                    Government under the National Science and Technology
                    Development Agency Bill (Now Act) 1977 Research Institute
                    (Establishment) Order 1977. NBRRI was established to conduct
                    integrated Research and Development activities into the
                    varied aspects of the building and road construction
                    industries. The mandate was later in 1993 expanded to
                    include R&D into all aspects of Engineering Materials
                    related to the construction industry.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </React.Fragment>
        <React.Fragment>
          <section className="portfolio-details">
            <div className="container">
              <OwlCarouselComponent></OwlCarouselComponent>
            </div>
          </section>
        </React.Fragment>
        <React.Fragment>
          <section id="services" className="services section-bg">
            <div className="container">
              <div className="section-title">
                <h2>Contact Info</h2>
              </div>

              <div className="row">
                <div className="col-lg-4 col-md-6 icon-box">
                  <div className="icon">
                    <i className="icofont-telephone"></i>
                  </div>
                  <h4 className="title">
                    <a href="">+234 806-718-2430</a>
                  </h4>
                </div>
                <div className="col-lg-4 col-md-6 icon-box">
                  <div className="icon">
                    <i className="icofont-email"></i>
                  </div>
                  <h4 className="title">
                    <a href="">info@nbrri.gov.ng</a>
                  </h4>
                </div>
                <div className="col-lg-4 col-md-6 icon-box">
                  <div className="icon">
                    <i className="icofont-earth"></i>
                  </div>
                  <h4 className="title">
                    <a href="">
                      10, NBRRI Way/I.T. Igbani Street, off Awolowo Way, Jabi,
                      Abuja
                    </a>
                  </h4>
                </div>
              </div>
            </div>
          </section>
        </React.Fragment>
      </React.Fragment>
    );
  }
}

export default HomePage;
